import { faExclamationCircle } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useCallback } from 'react'

type Props = {
	title: string
	tabKey: string
	isActive: boolean
	handleTabChange: (tabKey: string) => void
	showWarning?: boolean
	showNotice?: boolean
}

const TabTitle: React.FC<Props> = ({
	title,
	handleTabChange,
	tabKey,
	isActive,
	showWarning,
	showNotice = false,
}) => {
	const onClick = useCallback(() => {
		handleTabChange(tabKey)
	}, [handleTabChange, tabKey])

	return (
		<li>
			<button
				type="button"
				style={{ marginBottom: '-1px' }}
				className={
					'rounded-none font-semibold block pt-2 pb-3 px-4 border-b-2 ring-0 focus:ring-0 transition-colors duration-200 ease-in-out' +
					(isActive
						? ' border-purple-600 text-purple-900'
						: ' border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300')
				}
				onClick={onClick}
			>
				{title}
				{showWarning && (
					<FontAwesomeIcon
						icon={faExclamationCircle}
						className="text-red-500 ml-2"
					/>
				)}
				{showNotice && (
					<span className="absolute ml-1 bg-purple-700 rounded-full w-2 h-2" />
				)}
			</button>
		</li>
	)
}

export default TabTitle
